import { takeEvery, put, select, throttle } from 'redux-saga/effects'
import { delay } from 'redux-saga'

import config from '../Config'
import { Messages } from '../Socket'
import { isImage, participantToMessageType } from './helpers'

import { MessagingTypes, MessagingCreators, SocketTypes, SocketCreators } from '../../actions'
import { newParticipant } from './sagas/newParticipant'
import { participantLeave } from './sagas/participantLeave'

export function* submitMessage({ details }) {
  const { chatId, body, participant } = details
  yield put(
    MessagingCreators.displayMessage({
      text: body.text,
      type: 'user',
      name: participant.displayName,
      delay: 0,
    }),
  )

  const newMessage = Messages.newMessage({ chatId, body, participant })
  yield put(SocketCreators.sendSocketMessage(newMessage))
}

export function* receivedMessage({ result }) {
  const { body = {}, participant = {} } = result
  const messageType = participantToMessageType[participant.type]
  if (body.type === 'TEXT') {
    const isAgent = messageType === 'agent'
    if (isAgent) {
      yield put(SocketCreators.isTyping(false))
    }
    yield put(
      MessagingCreators.displayMessage({
        text: body.text,
        type: messageType,
        name: participant.displayName,
        delay: isAgent ? config.messageDelaySlow : 0,
      }),
    )
  } else if (body.type === 'FILE') {
    yield put(
      MessagingCreators.displayFileMessage({
        text: body.name,
        type: isImage(body.mimeType),
        name: participant.displayName,
        delay: config.messageDelay,
        fileInfo: {
          size: body.size,
          address: body.address,
        },
      }),
    )
  }

  const {
    Frame: { windowIsMinimized },
  } = yield select()

  /**
   * Temporary fix for incrementing unread messages whilst minimized
   * Future story to also increment unread count if the window is OPEN but
   * the new message is out of scroll view
   */

  if (windowIsMinimized) {
    yield put(MessagingCreators.addUnreadMessage())
  }
}

export function* customerTyping() {
  const {
    Chat: { chatId, stage },
  } = yield select()

  const participant = {
    type: 'CUSTOMER',
  }
  if (stage === config.stages.AGENT_CHAT || stage === config.stages.BOT_CHAT) {
    const isTypingMessage = Messages.isTyping({ chatId, participant })
    yield put(SocketCreators.sendSocketMessage(isTypingMessage))
  }
}

export function* agentTyping() {
  const {
    Chat: { agentIsTyping },
  } = yield select()
  if (agentIsTyping) {
    yield delay(config.typingDelay)
    yield put(SocketCreators.isTyping(false))
  }
}

export default [
  takeEvery(MessagingTypes.SUBMIT_MESSAGE, submitMessage),
  throttle(config.typingDelay, MessagingTypes.UPDATE_MESSAGE, customerTyping),
  takeEvery(SocketTypes.NEW_MESSAGE, receivedMessage),
  takeEvery(SocketTypes.NEW_PARTICIPANT, newParticipant),
  takeEvery(SocketTypes.PARTICIPANT_LEAVE, participantLeave),
  takeEvery(SocketTypes.IS_TYPING, agentTyping),
]
